import { firebase } from '../config/firebase.client';
const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : process.env.NODE_ENV === 'development';


export const fetchMunicipality = async (lat, lng) => {
    if (isDev) console.log('[DEV] fetchMunicipality chamada');

    try {
        const data = await firebase.callFunction('googleapis-googleApisGetMunicipality', {
            lat: lat,
            lng: lng,
        });


        if (data) return data;
        return 'Nenhum resultado encontrado';
    } catch (error) {
        const msg = error.message || 'Erro na função fetchMunicipality';
        console.error(msg);
    }
};

export const fetchPlacesAutocomplete = async (searchKeyword, location) => {
    if (isDev) console.log('[DEV] fetchPlacesAutocomplete chamada');

    const locationFormat = location ? `${location.location.lat},${location.location.lng}` : ''


    try {
        const data = await firebase.callFunction('googleapis-googleApisAutocomplete', {
            searchKeyword,
            location: locationFormat,
        });

        if (data && data.searchResults) return data.searchResults;
        return 'Nenhum resultado encontrado';
    } catch (error) {
        const msg = error.message || 'Erro na função fetchPlacesAutocomplete';
        console.error(msg);
    }
};

export const fetchCoordsfromPlace = async (place_id) => {
    if (isDev) console.log('[DEV] fetchCoordsfromPlace chamada');
    try {
        const data = await firebase.callFunction('googleapis-googleApisGetCoords', { place_id });
        if (data && data.coords) return data.coords;

        const msg = 'Nenhuma coordenada encontrada';
        console.error(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função fetchCoordsfromPlace';
        console.error(msg);
    }
};

export const fetchAddressfromCoords = async (latlng) => {
    if (isDev) console.log('[DEV] fetchAddressfromCoords chamada');
    try {
        const data = await firebase.callFunction('googleapis-googleApisGetAddress', { latlng });
        if (data && data.address) return data.address;

        const msg = 'Nenhum endereço encontrado';
        console.error(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função fetchAddressfromCoords';
        console.error(msg);
    }
};

export const getDistanceMatrix = async (startLoc, destLoc) => {
    if (isDev) console.log('[DEV] getDistanceMatrix chamada');
    try {
        const data = await firebase.callFunction('googleapis-googleApisGetDistanceMatrix', {
            start: startLoc,
            dest: destLoc,
        });

        if (data) return data;
        const msg = 'Erro ao obter distância';
        console.error(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função getDistanceMatrix';
        console.error(msg);
    }
};

export const getDirectionsApi = async (startLoc, destLoc, waypoints) => {
    if (isDev) console.log('[DEV] getDirectionsApi chamada');
    try {
        const body = { start: startLoc, dest: destLoc };
        if (waypoints) body.waypoints = waypoints;

        const data = await firebase.callFunction('googleapis-googleApisGetDirections', body);

        if (data && data.distance_in_km !== undefined) return data;
        const msg = 'Erro ao obter direções';
        console.error(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função getDirectionsApi';
        console.error(msg);
    }
};